import { Work} from '../container';
export default function WorkPage() {
  return <Work />;
}
